export enum CriteriaType {
  OpenText = 'TEXT',
  DateInput = 'DATE',
  DropDown = 'DROPDOWN'
}
